// This file provides a bridge between the React AuthContext and the OpenAPI client
// The auth provider will be set by the AuthProvider component

let authProvider: (() => Promise<string>) | null = null;
let authReadyPromise: Promise<void>;
let authReadyResolver: (() => void) | null = null;

// Create a promise that will resolve when auth is ready
authReadyPromise = new Promise<void>((resolve) => {
  authReadyResolver = resolve;
});

export function setAuthProvider(provider: () => Promise<string>) {
  authProvider = provider;
}

export function markAuthAsReady() {
  if (authReadyResolver) {
    authReadyResolver();
    authReadyResolver = null;
  }
}

export async function waitForAuth(): Promise<void> {
  await authReadyPromise;
}

export async function getAuthToken(): Promise<string> {
  // Wait for auth to be ready before attempting to get token
  await waitForAuth();
  
  if (!authProvider) {
    console.warn('Auth provider not set. Make sure AuthProvider is mounted.');
    return '';
  }
  
  try {
    const token = await authProvider();
    return token;
  } catch (error) {
    console.error('Failed to get auth token:', error);
    return '';
  }
}